// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments__3UfNa","single":"PhotoComments_single__2gVST"};